import { useEffect, useState } from "react";

export const useVisible = (option: {
  to?: HTMLElement | null;
  buffer?: number;
}) => {
  const { to, buffer = 0 } = option;
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const handleEvent = () => {
      const windowHeight = window.innerHeight;
      const toRect = to?.getBoundingClientRect();
      setIsVisible(windowHeight < (toRect?.top || 0) - buffer);
    };

    window.addEventListener("scroll", handleEvent);
    window.addEventListener("resize", handleEvent);
    handleEvent();

    return () => {
      window.removeEventListener("scroll", handleEvent);
      window.removeEventListener("resize", handleEvent);
    };
  }, [to, buffer]);

  return { isVisible };
};
